import { jsx as r, jsxs as B } from "react/jsx-runtime";
import { c as m } from "./index-65016bfa.mjs";
import t, { css as e } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as _ } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { b as C } from "./useSlots-a1aa6a84.mjs";
import { CloseButton as T } from "./closeButton.js";
import { Disclosures as $ } from "./disclosure.js";
import { Icon as b } from "./icon.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
const u = t.div`
  &.TopBanner-container {
    ${({
  theme: {
    components: { topBanner: n }
  }
}) => e(n.Container)};
  }
`, w = t.div`
  &.TopBanner {
    ${({
  theme: {
    components: { topBanner: n }
  }
}) => e(n.TopBanner)};
  }
`, S = t(b)`
  &.Content-wrapper_notify-icon {
    ${({
  theme: {
    components: { topBanner: n }
  }
}) => e(n.NotifyIcon)};
  }
`, x = t.div`
  &.TopBanner_content {
    ${({
  theme: {
    components: { topBanner: n }
  }
}) => e(n.Content)};
  }
`, I = t.div`
  &.TopBanner_content-body {
    ${({
  theme: {
    components: { topBanner: n }
  }
}) => e(n.Body)};
  }
`, d = t(T)`
  &.TopBanner_CloseButton {
    ${({
  theme: {
    components: { topBanner: n }
  }
}) => e(n.CloseButton)};
  }
`, f = ({ variant: n = "neutral", body: y, disclosures: o, onClickClose: p, children: N, ...h }) => {
  var i, l, c;
  const s = _({ label: "Top Banner" }), a = C(N, { CloseButton: f.CloseButton }, C.PickType.LAST);
  return /* @__PURE__ */ r(
    u,
    {
      role: "alert",
      ...s,
      ...h,
      className: m(["TopBanner-container", `TopBanner-container--${n}`]),
      children: /* @__PURE__ */ B(w, { className: "TopBanner", children: [
        /* @__PURE__ */ r(
          S,
          {
            "aria-hidden": !0,
            "aria-label": n,
            className: "Content-wrapper_notify-icon",
            size: "m",
            name: n === "warning" || n === "error" ? "warningFilled" : "informationFilled"
          }
        ),
        /* @__PURE__ */ B(x, { className: "TopBanner_content", children: [
          /* @__PURE__ */ r(I, { className: "TopBanner_content-body", children: y || a.rest }),
          o && /* @__PURE__ */ r(
            $,
            {
              disclosureContent: o == null ? void 0 : o.disclosureContent,
              id: o == null ? void 0 : o.id,
              className: m(["TopBanner_content_Disclosures", o == null ? void 0 : o.className]),
              disclosureTitleColor: o == null ? void 0 : o.disclosureTitleColor,
              style: o == null ? void 0 : o.style
            }
          )
        ] }),
        (p || ((i = a.CloseButton) == null ? void 0 : i.props)) && /* @__PURE__ */ r(
          d,
          {
            onClick: p,
            ...(l = a.CloseButton) == null ? void 0 : l.props,
            surface: "dark",
            color: "default",
            size: "small",
            className: m(["TopBanner_CloseButton", (c = a.CloseButton) == null ? void 0 : c.props.className])
          }
        )
      ] })
    }
  );
};
f.CloseButton = T;
export {
  f as TopBanner
};
